import styled from '@emotion/styled';

const FamilyMembers = styled('div')(({ theme }) => ({
  borderTop: `1px solid ${theme.colors.gray.primary}`,
  marginBottom: '1rem',
  marginTop: '2rem',
}));

export default FamilyMembers;
